var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageVedioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33334V26.6666H5.33334V5.33334H32ZM34.6666 0H2.66666C1.95942 0 1.28115 0.280952 0.781048 0.78105C0.280952 1.28115 0 1.95942 0 2.66666V29.3334C0 30.0406 0.280952 30.7188 0.781048 31.219C1.28115 31.719 1.95942 32 2.66666 32H34.6666C35.374 32 36.0522 31.719 36.5522 31.219C37.0524 30.7188 37.3334 30.0406 37.3334 29.3334V20L48 30.6666V1.33333L37.3334 12V2.66666C37.3334 1.95942 37.0524 1.28115 36.5522 0.78105C36.0522 0.280952 35.374 0 34.6666 0Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageVedioIcon);
export default __webpack_public_path__ + "static/media/image-vedio-icon.047ec7b3c3904cccca6b7175da45ed77.svg";
export { ForwardRef as ReactComponent };